import { useLanguage } from "@/contexts/LanguageContext"
import { ArrowUpRight } from "lucide-react"

const ProjectsSection = () => {
  const { t } = useLanguage()
  const projects = [
    { title: t('projects.weather.title'), category: t('projects.weather.category'),
      problem: t('projects.weather.problem'), approach: t('projects.weather.approach'),
      result: t('projects.weather.result'), metrics: t('projects.weather.metrics') },
    { title: t('projects.mvp.title'), category: t('projects.mvp.category'),
      problem: t('projects.mvp.problem'), approach: t('projects.mvp.approach'),
      result: t('projects.mvp.result'), metrics: t('projects.mvp.metrics') },
    { title: t('projects.automation.title'), category: t('projects.automation.category'),
      problem: t('projects.automation.problem'), approach: t('projects.automation.approach'),
      result: t('projects.automation.result'), metrics: t('projects.automation.metrics') },
  ]
  return (
    <section id="projects" className="py-24 md:py-32 bg-je-white">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-5">
            <span className="eyebrow mb-5">04 — Cas clients</span>
            <h2 className="text-section-title font-serif font-medium text-je-black mt-4 text-balance">{t('projects.title')}</h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-je-gray-dark text-pretty">{t('projects.subtitle')}</p>
          </div>
        </div>

        <div className="space-y-px bg-je-navy/15">
          {projects.map((p, i) => (
            <article key={i} className="bg-je-white py-10 md:py-14 group hover:bg-je-ivory transition-colors">
              <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
                <div className="col-span-12 md:col-span-1 font-mono text-xs tracking-widest text-je-gray-dark pt-2">
                  0{i + 1}
                </div>
                <div className="col-span-12 md:col-span-4">
                  <div className="font-mono text-xs uppercase tracking-widest text-je-red mb-3">{p.category}</div>
                  <h3 className="font-serif text-3xl md:text-4xl font-medium text-je-black leading-tight mb-4">{p.title}</h3>
                  <div className="font-mono text-xs text-je-navy/70">{p.metrics}</div>
                </div>
                <div className="col-span-12 md:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-6">
                  {[
                    { l: t('projects.problem'), v: p.problem },
                    { l: t('projects.approach'), v: p.approach },
                    { l: t('projects.result'), v: p.result },
                  ].map((b, j) => (
                    <div key={j}>
                      <div className="font-mono text-[10px] uppercase tracking-widest text-je-gray-dark mb-2">{b.l}</div>
                      <p className="text-sm text-je-navy/85 leading-relaxed">{b.v}</p>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
export default ProjectsSection
